// RAFAC Join

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import {CreateIfExistsVueApp} from "./utils/vueCreator";
import Invitation from "./modules/invitation/invitation";

CreateIfExistsVueApp(Invitation, '#invitationApp');
